"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortSearchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_select_1 = __importDefault(require("react-select"));
const useFetch_1 = __importDefault(require("../../hooks/useFetch"));
const react_1 = require("react");
const useDeepMemo_1 = require("../../hooks/useDeepMemo");
const lodash_1 = require("lodash");
const apiUtils_1 = require("../../util/apiUtils");
const PortSearchInput = ({ value, onChange, }) => {
    const [ports, setUrl] = (0, useFetch_1.default)(undefined, undefined);
    const [emptyOptions, setEmptyOptions] = (0, react_1.useState)(true);
    const [options] = (0, useDeepMemo_1.useDeepMemo)(() => {
        if (emptyOptions ||
            ports.status !== apiUtils_1.LoaderStatus.Success ||
            !(0, lodash_1.values)(ports.data).length) {
            return [[]];
        }
        return [
            (0, lodash_1.values)(ports.data).map((port) => ({
                value: port.un_code,
                label: `${port.name} (${port.un_code})`,
            })),
        ];
    }, [emptyOptions, ports]);
    const handleInput = (value) => {
        if (value.length < 3) {
            setEmptyOptions(true);
        }
        else {
            setEmptyOptions(false);
            setUrl(`calculator/complete?port=${value}`);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_select_1.default, { isSearchable: true, placeholder: "\u2026Search for port", value: value ?? null, options: options, onChange: (v) => (v !== null ? onChange(v.value, v.label) : null), onInputChange: handleInput }));
};
exports.PortSearchInput = PortSearchInput;
